const state = {
  isSyncedSuccessfully: null,
}

export default state
